import {
  BookOpen,
  Briefcase,
  Calendar,
  CheckSquare,
  CreditCard,
  FileText,
  Layers,
  Layout,
  ShoppingCart,
  Sliders,
  Tool,
  Users,
} from "react-feather";

// Each top-level item has its own icon: the sidebar autohides to an icon
// bar, where the icon is all that shows.

const toolsSection = [
  {
    href: "/tools",
    icon: Tool,
    title: "Tools",
    children: [
      {
        href: "/tools/wallCalculator",
        title: "Wall Thickness Calculator",
      },
      {
        href: "/tools/coc",
        title: "COC Worksheet",
      },
    ],
  },
  {
    href: "/forms",
    icon: FileText,
    title: "Forms",
    children: [
      {
        href: "/forms/level10",
        title: "Meeting",
      },
    ],
  },
];

const departmentsSection = [
  {
    href: "/departments",
    icon: Layers,
    title: "Departments",
    children: [
      {
        href: "/logs/mpi",
        title: "Mag. Particle Inspection",
      },
      {
        href: "/logs/mpi/fluids",
        title: "MPI Fluids",
      },
      {
        href: "/logs/rebuild",
        title: "Rebuild",
        //allowed: ["JOB PULLER"],
      },
      {
        href: "/logs/hydro",
        title: "Hydrotesting",
      },
      {
        href: "/departments/utt",
        title: "Ultrasonic Thickness",
      },
      {
        href: "/departments/min-wall",
        title: "Min Wall Catalog",
        allowed: ["ADMIN"],
      },
      {
        href: "/departments/maintenance",
        title: "Maintenance",
      },
    ],
  },
];

const logsSection = [
  {
    href: "/logs",
    icon: BookOpen,
    title: "Logs",
    children: [
      {
        href: "/logs/mpi",
        title: "Mag. Particle Inspection",
      },
      {
        href: "/logs/mpi/fluids",
        title: "MPI Fluids",
      },
      {
        href: "/logs/rebuild",
        title: "Rebuild",
        //allowed: ["JOB PULLER"],
      },
      {
        href: "/logs/hydro",
        title: "Hydrotesting",
      },
      {
        href: "/logs/utt",
        title: "Ultrasonic Thickness",
      },
      {
        href: "/logs/nonconformance",
        title: "Nonconformance",
      },
      {
        href: "/logs/slings",
        title: "Slings",
      },
      {
        href: "/logs/kanban",
        title: "Kanban",
      },
    ],
  },
];

const pagesSection = [
  {
    href: "/dashboard/default",
    icon: Sliders,
    title: "Dashboard",
  },
  {
    href: "/pages",
    icon: Layout,
    title: "Pages",
    children: [
      {
        href: "/pages/profile",
        title: "Profile",
      },
      {
        href: "/pages/settings",
        title: "Settings",
      },
      {
        href: "/pages/pricing",
        title: "Pricing",
      },
      {
        href: "/pages/chat",
        title: "Chat",
      },
    ],
  },
  {
    href: "/projects",
    icon: Briefcase,
    title: "Projects",
    badge: (count) => count || "8",
    dataLocation: "projects",
    countChild: "status",
    countTerm: "In Progress",
  },
  {
    href: "/orders",
    icon: ShoppingCart,
    title: "Jobs",
  },
  {
    href: "/invoices",
    icon: CreditCard,
    title: "Invoices",
    children: [
      {
        href: "/invoices",
        title: "List",
      },
      {
        href: "/invoices/detail",
        title: "Detail",
      },
    ],
  },
  {
    href: "/tasks",
    icon: CheckSquare,
    title: "Tasks",
    badge: (count) => count || "17",
  },
  {
    href: "/calendar",
    icon: Calendar,
    title: "Calendar",
  },
  {
    href: "/users",
    icon: Users,
    title: "Users",
  },
];

const navItems = [
  {
    title: "Pages",
    pages: pagesSection,
  },
  {
    title: "Logs",
    pages: logsSection,
    //allowed: ["COORDINATOR"],
  },
  {
    title: "Departments",
    pages: departmentsSection,
    //allowed: ["COORDINATOR"],
  },
  {
    title: "Tools",
    pages: toolsSection,
    //allowed: ["COORDINATOR"],
  },
];

export default navItems;
